import { render, staticRenderFns } from "./SingleChoice.vue?vue&type=template&id=3ce2a931&"
import script from "./SingleChoice.vue?vue&type=script&lang=js&"
export * from "./SingleChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports